import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';

import { Spinner } from 'components/Loading/Spinner/Spinner';
import { AiTool } from 'components/pages/AppLibrary/components/AiTool';

import { useGetAIToolsContentQuery } from 'store/apis/cmsApi';
import { useQueryError } from 'utilities/hooks/useQueryError/useQueryError';
import { useCheckPermission } from 'utilities/hooks/useCheckPermission/useCheckPermission';

import { aiToolsSelector } from 'store/slices/cmsSlice';
import { isStaffSelector } from 'store/slices/userDetailsSlice';

import { PERMISSIONS } from 'constants/permissions';
import { ERROR_FETCHING_AI_TOOLS_MESSAGE } from 'components/pages/AppLibrary/constants';
import { AI_MODELS } from 'components/AITools/constants/common';

import { useAIToolsStyles } from 'components/pages/AppLibrary/styles';

export const AITools = () => {
  const { error, isLoading } = useGetAIToolsContentQuery();
  const { classes } = useAIToolsStyles();

  const aiToolsData = useSelector(aiToolsSelector);
  const isStaff = useSelector(isStaffSelector);
  const isAiosynPermission = useCheckPermission(PERMISSIONS[AI_MODELS.aiosyn]);
  const showAiosyn = isStaff || isAiosynPermission;
  const filteredAiToolsData = aiToolsData.filter(
    (tool) => !(tool.toolId === AI_MODELS.aiosyn && !showAiosyn),
  );

  useQueryError(error, ERROR_FETCHING_AI_TOOLS_MESSAGE);

  if (isLoading) {
    return (
      <Box className={classes.spinner}>
        <Spinner />
      </Box>
    );
  }

  return (
    <Box className={classes.modelsWrapper}>
      {filteredAiToolsData.map((tool) => (
        <AiTool key={tool.id} aiTool={tool} />
      ))}
    </Box>
  );
};
